import React from 'react';
import {
    withStyles,
    IconButton,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Divider,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import AppData from '../../model/AppData';

const styles = (theme) => ({
    icon: {
        color: '#726C7E'
    },
});

class SafetyDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: true,
        };

        this._onClickPsw = this._onClickPsw.bind(this);
    }

    _onClickPsw() {
        this.props.history.push({ pathname: '/forgetpwd' });
    }

    // 账号安全
    render() {
        const { classes } = this.props;
        return (
            <MBack title="修改密码">
                <ListItem>
                    <ListItemText style={{ color: 'white' }} primary="手机号" />
                    <ListItemSecondaryAction>
                        <ListItemText secondary={AppData.me.PhoneNum} ></ListItemText>
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider style={{ backgroundColor: '#241E3A' }} />
                <ListItem button onClick={() => this._onClickPsw()}>
                    <ListItemText style={{ color: 'white' }} primary="修改密码" />
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete">
                            <ChevronRightOutlinedIcon style={{ color: '#E2E2E2', fontSize: 20 }} />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider style={{ backgroundColor: '#241E3A' }} />
            </MBack>
        );
    }
}

export default withRouter(withStyles(styles)(SafetyDialog));